import React from 'react';
import { Icon, Tag as USWDSTag } from '@ver-uds/uswds-react';
import classNames from 'classnames';

export interface ChipProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  ariaLabel?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
const Chip = ({ children, onClick, className, id, ariaLabel }: ChipProps): JSX.Element => {
  return (
    <USWDSTag id={id} className={classNames(className, 'ver-chip')}>
      {children}
      <button type="button" aria-label={ariaLabel} className="ver-chip__button" onClick={onClick}>
        <Icon name="close" />
      </button>
    </USWDSTag>
  );
};

export default Chip;
